import { loadingManagementApi } from 'feature/loading-management/loadingManagementApi';
import * as R from 'ramda';

const getUrl = R.concat('terminal-allocations/');
const terminalAllocationLoadingPercentageEndpoints = loadingManagementApi.injectEndpoints({
  endpoints: ({ query }) => ({
    getLoadingPercentage: query({
      query: params => ({
        params,
        url: getUrl('get-loading-percentages'),
      }),
    }),
  }),
});

/* eslint-disable import/prefer-default-export */
export const { useGetLoadingPercentageQuery } = terminalAllocationLoadingPercentageEndpoints;
